import { Link } from "@inertiajs/react";
import BlankLayout from "../BlankLayout";
import { oauth } from "@/api"

const Index = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#1675ff] via-[#0c4db8] to-[#0a3d8a] flex items-center justify-center relative overflow-x-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute w-full h-full"></div>
      </div>

      <div className="max-w-6xl w-full px-8 md:px-4">
        <div className="text-center text-white relative z-10">
          <div className="mb-12">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-2 bg-gradient-to-r from-white to-gray-100 bg-clip-text text-transparent">
              MiraclePlus
            </h1>
            <p className="text-lg md:text-xl opacity-90 font-light tracking-widest">
              智能招聘平台
            </p>
          </div>

          <div className="mb-16">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold mb-6 leading-tight">
              连接优秀人才与理想机会
            </h2>
            <p className="text-lg md:text-xl opacity-90 max-w-2xl mx-auto leading-relaxed">
              基于AI的智能匹配系统，为企业和求职者提供精准的人才配对服务
            </p>
          </div>

          <div className="mt-12">
            <Link href={oauth.authorize.path()} className="group inline-flex items-center gap-3 bg-white/95 backdrop-blur-sm text-indigo-600 px-10 py-4 rounded-full text-lg font-semibold no-underline transition-all duration-300 shadow-lg border border-white/20 hover:bg-white hover:shadow-xl hover:-translate-y-0.5 hover:no-underline">
              <span className="text-xl">🚀</span>
              <span className="font-semibold">立即登录</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

Index.layout = (page) => <BlankLayout children={page} />;

export default Index;
